export const lat = {
  Header: {
    title: 'Saglasnost na sadržinu i izgled pečata',
    titleShort: 'ePecat',
    Labels: {
      homePage: 'Početna strana',
      roles: 'Uloge korisnika',
      adminPanel: 'Admin panel',
      users: 'Korisnici',
      decision: 'Rešenja',
      decisionLink:
        'Rešenja o zahtevima za davanje saglasnosti na sadržinu i izgled pečata',
      decisionType: 'Tip rešenja',
      signet: 'Pečati',
      codebooks: 'Šifarnici',
      services: 'Usluge',
      requests: 'Zahtevi',
      requestForSignetApproval:
        'Zahtev za davanje saglasnosti na sadržinu i izgled pečata',
      requestForSignetStatus: 'Prijava promene statusa pečata',
      signetInfo: 'Informacije o pečatu',
      signetLink: 'Dostavljanje podataka о izrađenim pečatima',
      kjs: 'Pregled KJS',
      place: 'Pregled gradova\\opština',
      municipality: 'Pregled sedišta organa',
      documents: 'Dokumenti',
      elSignetPreview: 'Pregled spoljnog prikaza elektronskog pečata',
      instruction: 'Uputstvo',
      NotificationMessages: {
        instruction: 'Korisničko uputstvo',
        unsuccessDownload: 'Došlo je do greške prilikom preuzimanja dokumenta',
      },
    },

    Buttons: {
      signIn: 'Prijava',
      signOut: 'Odjavi se',
    },
  },

  Footer: {
    title: 'Portal eUprava Republike Srbije',
    Buttons: {
      toTop: 'Vrh strane',
    },
    text:
      'Veb prezentacija je licencirana pod uslovima licence Creative Commons Autorstvo-Nekomercijalno-Bez prerade 3.0 Srbija. Veb projekat',
    linkText: 'Uslovi korišćenja',
  },

  SearchFilter: {
    placeholder: 'Pretraga...',
  },

  LoadingIndicator: {
    syncKjsMessage: 'Trenutno je u toku sinhronizacija KJS-a',
    syncKjsAdditionalMessage: 'Molimo Vas sačekajte.',
  },

  Global: {
    Button: {
      save: 'Sačuvaj',
      edit: 'Izmeni',
      delete: 'Obriši',
      deactivate: 'Deaktiviraj',
      goBack: 'Vrati nazad',
      quit: 'Odustani',
      print: 'Odštampaj',
      yes: 'DA',
      no: 'NE',
      confirm: 'U redu',
      toLandingPage: 'Povratak na početnu stranicu',
    },
    EnhancedTable: {
      rowPerPage: 'Broj redova:',
      of: ' od ',
    },
    Lang: {
      sr: 'Ћирилица',
      lat: 'Latinica',
    },
    NotificationMessages: {
      errorTitle: 'Greška',
      errorMessage: 'Token je istekao',
    },
  },

  Enums: {
    Role: {
      superAdmin: {
        text: 'Super administrator',
        value: 'superAdmin',
      },
      admineu: {
        text: 'Administrator KEU',
        value: 'admineu',
      },
      adminmduls: { text: 'Administrator MDULS-a i AP-a', value: 'adminmduls' },
      olMduls: { text: ' Obrađivač MDULS-a i AP-a', value: 'olMduls' },
      olOrgana: { text: 'Ovlašćeno lice organa', value: 'olOrgana' },
      inspektorat: {
        text: 'Ovlašćeno lice Upravnog inspektorata',
        value: 'inspektorat',
      },
    },
    DecisionStatus: {
      IN_PREPARATION: {
        text: 'U izradi',
        // color: 'green',
      },
      SENT: {
        text: 'Poslato',
        // color: 'yellow',
      },
      SENT_AGAIN: {
        text: 'Ponovo poslato',
        // color: 'purple',
      },
      VERIFIED: {
        text: 'Potpisano',
        // color: 'blue',
      },
      DELIVERY_ACCEPTED: {
        text: 'Prihvaćena dostava',
        // color: 'blue',
      },
      REJECTED: {
        text: 'Odbijeno',
        // color: 'aqua',
      },
      DELIVERED_WITHOUT_TAKEOVER: {
        text: 'Dostavljeno bez preuzimanja',
        // color: 'orange',
      },
      DELIVERED: {
        text: 'Dostavljeno',
        // color: 'olive',
      },
      FINAL: {
        text: 'Pravosnažno',
        // color: 'red',
      },
      SUSPENDED: {
        text: 'Stornirano',
        // color: 'lime',
      },
    },

    DecisionStatusList: [
      { value: 'IN_PREPARATION' },
      { value: 'SENT' },
      { value: 'SENT_AGAIN' },
      { value: 'DELIVERY_ACCEPTED' },
      { value: 'REJECTED' },
      { value: 'DELIVERED_WITHOUT_TAKEOVER' },
      { value: 'DELIVERED' },
      { value: 'FINAL' },
      { value: 'SUSPENDED' },
    ],

    SignetStatus: {
      APPROVED: {
        text: 'Odobren',
        value: 'APPROVED',
      },
      REJECTED: {
        text: 'Odbijen',
        value: 'REJECTED',
      },
      COMPLEMENT_REQUIRED: {
        text: 'Potrebna dopuna',
        value: 'COMPLEMENT_REQUIRED',
      },
      COMPLEMENTED: {
        text: 'Dopunjen',
        value: 'COMPLEMENTED',
      },
      LOST: {
        text: 'Izgubljen',
        value: 'LOST',
      },
      TERMINATED: {
        text: 'Prestao da važi',
        value: 'TERMINATED',
      },
      COMPROMISED: {
        text: 'Kompromitovan',
        value: 'COMPROMISED',
      },
      NOT_CONSENTED: {
        text: 'Nije dobijena saglasnost',
        value: 'NOT_CONSENTED',
      },
      DELIVERED: {
        text: 'Dostavljen',
        value: 'DELIVERED',
      },
      FINISHED: {
        text: 'Završen',
        value: 'FINISHED',
      },
      REVOKED: {
        text: 'Opozvan',
        value: 'REVOKED',
      },
      CANCELED: {
        text: 'Storniran',
        value: 'CANCELED',
      },
    },

    SignetState: {
      IN_USE: {
        text: 'U upotrebi',
        value: 'IN_USE',
      },
      OUT_OF_USE: {
        text: 'Van upotrebe',
        value: 'OUT_OF_USE',
      },
      READY_TO_USE: {
        text: 'Spreman za upotrebu',
        value: 'READY_TO_USE',
      },
    },

    Status: {
      IN_PREPARATION: {
        text: 'U pripremi',
        value: 'IN_PREPARATION',
      },
      SUBMIT: {
        text: 'Podnet',
        value: 'SUBMIT',
      },
      WITHDRAWN: {
        text: 'Povučen',
      },
      IN_PROCESSING: {
        text: 'U obradi',
      },
      REQUIRED_COMPLEMENTATION: {
        text: 'Potrebna dopuna',
        value: 'REQUIRED_COMPLEMENTATION',
      },
      COMPLEMENTED: {
        text: 'Dopunjen',
        value: 'COMPLEMENTED',
      },
      ACCEPTED: {
        text: 'Odobren',
      },
      REJECTED: {
        text: 'Odbačen',
      },
      REFUSE: {
        text: 'Odbijen',
      },
      CANCELED: {
        text: 'Storniran',
      },
      COMPLETED: {
        text: 'Završen',
      },
      ARCHIVED: {
        text: 'Arhiviran',
      },
    },

    CoatOfArmsAppearance: {
      LARGE_RS: {
        text: 'Veliki GRB RS',
        value: 'LARGE_RS',
      },
      SMALL_RS: {
        text: 'Mali GRB RS',
        value: 'SMALL_RS',
      },
      TRADITIONAL_APV: {
        text: 'Mali GRB RS, Grb APV i tradicionalni grb APV',
        value: 'TRADITIONAL_APV',
      },
    },

    NationalMinorities: {
      CRNOGORCI: {
        text: 'CRNOGORSKI',
        value: 'CRNOGORCI',
      },
      HRVATI: {
        text: 'HRVATSKI',
        value: 'HRVATI',
      },
      BUNJEVCI: {
        text: 'BUNJEVAČKI',
        value: 'BUNJEVCI',
      },
      BUGARI: {
        text: 'BUGARSKI',
        value: 'BUGARI',
      },
      BOSNJACI: {
        text: 'BOSANSKI',
        value: 'BOSNJACI',
      },
      MADJARI: {
        text: 'MAĐARSKI',
        value: 'MADJARI',
      },
      ROMI: {
        text: 'ROMSKI',
        value: 'ROMI',
      },
      RUMUNI: {
        text: 'RUMUNSKI',
        value: 'RUMUNI',
      },
      RUSINI: {
        text: 'RUSINSKI',
        value: 'RUSINI',
      },
      SLOVACI: {
        text: 'SLOVAČKI',
        value: 'SLOVACI',
      },
      ALBANCI: {
        text: 'ALBANSKI',
        value: 'ALBANCI',
      },
      VLASI: {
        text: 'VLAŠKI',
        value: 'VLASI',
      },
      CESI: {
        text: 'ČEŠKI',
        value: 'CESI',
      },
      MAKEDONCI: {
        text: 'MAKEDONSKI',
        value: 'MAKEDONCI',
      },
    },

    Users: {
      admin: {
        text: 'Admin',
        value: 'admin',
      },
      olmduls: {
        text: 'Ovlašćeno lice MDULS-a',
        value: 'olmduls',
      },
      olorgana: {
        text: 'Ovlašćeno lice organa',
        value: 'olorgana',
      },
      olorganaAP: {
        text: 'Ovlašćeno lice organa AP',
        value: 'olorganaAP',
      },
      olmdulsAP: {
        text: 'Ovlašćeno lice MDULS-a AP',
        value: 'olmdulsAP',
      },
    },

    DecisionTypeTypes: [
      {
        text: 'Електронски формат',
        value: 'DIGITAL_SIGNET',
      },
      {
        text: 'Формат отиска',
        value: 'IMPRINT_SIGNET',
      },
      {
        text: 'Електронски формат за АП',
        value: 'DIGITAL_SIGNET_AP',
      },
    ],

    AutonomousProvince: [
      {
        text: 'Војводина',
        value: 'VOJVODINA',
        valueForFilter: 0,
      },
      {
        text: 'Косово и Метохија',
        value: 'KOSOVO_I_METOHIJA',
        valueForFilter: 1,
      },
      {
        text: 'Ништа од наведеног',
        value: null,
        valueForFilter: null,
      },
    ],
  },

  Instruction: {
    instruction: 'Korisničko uputstvo',
    content: 'Ovde možete preuzeti korisničko uputstvo.',
    tooltip: 'Preuzmite korisničko uputstvo',
    NotificationMessages: {
      instruction: 'Korisničko uputstvo',
      unsuccessDownload: 'Došlo je do greške prilikom preuzimanja dokumenta',
    },
  },

  RoleList: {
    rowPerPage: 'Broj redova',
    of: ' od ',
  },
  RoleTable: {
    HeaderColumns: {
      roleName: 'Ime uloge',
      actions: 'Akcije',
      delete: 'Brisanje',
    },
    titleTable: 'Uloge korisnika',
  },

  RoleRow: {
    ConfirmDialog: {
      confirmMessage: 'Da li ste sigurni da želite da obrišete rolu?',
      confirmDelete: '',
    },
  },
  SignetTable: {
    HeaderColumns: {
      request: 'Delovodni broj predmeta',
      uniqueNumber: 'Jedinstveni serijski broj',
      organizationalUnit: 'Organ',
      plannedStart: 'Datum početka upotrebe',
      statusChangedDate: 'Datum promene statusa',
      authorizedPerson: 'Ovlašćeno lice',
      signetState: 'Stanje',
      signetStatus: 'Status',
      processing: 'Obrada',
    },
    titleTable: 'Evidencija pečata',
  },
  ModalForUpdateRole: {
    Labels: {
      title: 'Izmena role',
    },
    Placeholders: {
      roleName: 'Naziv role',
      ActionsTable: {
        allActionsListTitle: 'Lista svih akcija',
        chosenActionsListTitle: 'Lista izabranih akcija',
        selectAllActions: 'Obeleži sve akcije',
      },
    },
    Errors: {
      roleNameEmpty: 'Potrebno je uneti naziv role.',
    },
  },
  ModalForAddRole: {
    Errors: {
      roleNameEmpty: 'Ne može da bude prazno ime',
    },
    Labels: {
      title: 'Naslov',
    },
    Placeholders: {
      roleName: 'Naziv role',
      ActionsTable: {
        allActionsListTitle: 'Lista svih akcija',
        chosenActionsListTitle: 'Lista izabranih akcija',
        selectAllActions: 'Obeleži sve akcije',
      },
    },
  },
  DecisionList: {
    rowPerPage: 'Broj redova',
    of: ' od ',
  },

  SignetList: {
    rowPerPage: 'Broj redova',
    of: ' od ',
  },

  DecisionTable: {
    Labels: {
      titleTable: 'Rešenja',
    },
    HeaderColumns: {
      requestForSignetApproval: 'Delovodni broj predmeta',
      decisionStatus: 'Status',
      decisionType: 'Tip rešenja',
      dateCreated: 'Datum kreiranja',
      download: 'Preuzimanje',
      edit: 'Izmena',
      delete: 'Brisanje',
    },
    Tooltips: {
      addNew: 'Dodaj novo rešenje',
    },
  },

  DecisionRow: {
    ConfirmDialog: {
      confirmMessage: 'Da li želite da obrišete rešenje?',
      confirmDelete: ', obriši!',
    },
    NotificationMessages: {
      decisionFinalTitle: 'Rešenje',
      decisionTitleError: 'Greška',
      successDownload: 'Uspešno ste preuzeli dokument',
      unsuccessDownload: 'Došlo je do greške prilikom preuzimanja dokumenta',
    },
  },

  ModalForDecisionUpdateAndPreview: {
    Labels: {
      title: 'Pregled rešenja',
    },
    Errors: {
      decisionType: 'Tip rešenja je obavezno polje',
    },
    Placeholders: {
      decisionStatus: 'Status',
      dateCreated: 'Datum kreiranja',
      decisionType: 'Tip rešenja',
    },
  },

  ModalForAddSubmissionDataSignet: {
    Labels: {
      title: 'Dostavljanje podataka о izrađenim pečatima',
      titleLook: 'Spoljni prikaz elektronskog pečata',
      titleDestroyed: 'Zapisnik о uništenju pečata',
    },
    Errors: {
      uniqueSerialNumber: 'Potrebno je uneti jedinstven serijski broj',
      plannedStart: 'Potrebno je uneti datum nabavke',
      validUntil: 'Potrebno je uneti datum vazenja',
      invalidValidUntil:
        'Datum početka važenja mora biti manji od roka važenja',
      imageNotUploaded: 'Fajl nije učitan',
      invalidFileSize: 'Veličina fajla je veća od 10MB',
      invalidFormat: 'Fajl mora da bude u .pdf ili .docx formatu',
      beginOfUsage: 'Potrebno je uneti datum početka upotrebe',
    },
    Placeholders: {
      uploadSignetLook: 'Učitajte izgled pečata',
      uploadSignetDestroyed: 'Učitajte zapisnik о uništenju pečata',
      uniqueSerialNumber: 'Jedinstveni serijski broj',
      plannedStart: 'Datum nabavke',
      validUntil: 'Datum važenja',
      questionDestroyedAttachment: 'Priložiti zapisnik о uništenju pečata?',
      validPeriod: 'Rok važenja',
      validPeriodInfo: 'Rok važenja je u godinama',
      beginOfUsage: 'Početak upotrebe',
    },
  },

  ModalForAddComplementRequestApproval: {
    Labels: {
      title:
        'Dopuna zahteva za davanje saglasnosti na sadržinu i izgled pečata',
    },
    Errors: {
      description: 'Potrebno je uneti obrazloženje',
      descriptionLength: 'Opis može sadržati najviše 2000 karaktera',
    },
    Placeholders: {
      description: 'Unesite obrazloženje...',
      descriptionForPreview: 'Zahtev za dopunu',
    },
  },

  ModalForAddComplementSignet: {
    Labels: {
      title: 'Dopuna zahteva za dostavljanje podataka о izrađenim pečatima',
    },
    Errors: {
      description: 'Potrebno je uneti obrazloženje',
      descriptionLength: 'Opis može sadržati najviše 2000 karaktera',
    },
    Placeholders: {
      description: 'Unesite obrazloženje...',
      descriptionForPreview: 'Zahtev za dopunu',
    },
  },

  UploadFormTable: {
    name: 'Naziv',
    delete: 'Obriši',
    messageMultiple: 'Potrebno je učitati sve neophodne fajlove odjednom',
    messageSingle: 'Omogućeno je učitavanje samo jednog fajla',
  },

  ModalForAddUser: {
    Labels: {
      title: 'Dodavanje novog korisnika',
    },
    Errors: {
      umcn: 'Potrebno je uneti JMBG.',
      firstName: 'Potrebno je uneti ime.',
      lastName: 'Potrebno je uneti prezime.',
      username: 'Potrebno je uneti imejl.',
      kjs: 'Potrebno je uneti KJS.',
    },
    Placeholders: {
      umcn: 'JMBG',
      firstName: 'Ime',
      lastName: 'Prezime',
      username: 'Imejl',
      telephone: 'Telefon (fiksni)',
      cellPhone: 'Telefon (mobilni)',
      phoneNumber: 'Broj telefona',
      place: 'Grad\\Opština',
      municipalities: 'Sedište organa',
      institutionType: 'Tip organa',
      institutionName: 'Naziv organa',
      kjs: 'KJS',
      role: 'Rola',
      pib: 'PIB',
      uniqueKjsNumber: 'Jedinstveni broj KJS',
    },
    NotificationMessages: {
      userTitle: 'Korisnik',
      umcnError: 'Korisnik sa unetim JMBG-om već postoji u bazi podataka!',
      invalidUmcnError: 'Uneli ste nevalidan JMBG!',
      errorTitle: 'Greška',
      usernameError:
        'Korisnik sa unetim korisničkim imenom već postoji u bazi podataka!',
      umcnAndUsernameError:
        'Korisnik sa unetim JMBG-om i korisničkim imenom već postoji u bazi podataka!',
      creationSuccessMessage: 'Korisnik je uspešno kreiran',
    },
    Tooltips: {
      addItem: 'Dodaj KJS',
    },
  },

  ModalForUpdateUser: {
    Labels: {
      title: 'Izmena podataka о korisniku',
    },
    Errors: {
      umcn: 'Potrebno je uneti JMBG.',
      firstName: 'Potrebno je uneti ime.',
      lastName: 'Potrebno je uneti prezime.',
      username: 'Potrebno je uneti imejl.',
      kjs: 'Potrebno je uneti KJS.',
    },
    Placeholders: {
      umcn: 'JMBG',
      firstName: 'Ime',
      lastName: 'Prezime',
      username: 'Imejl',
      phoneNumber: 'Broj telefona',
      telephone: 'Telefon (fiksni)',
      cellPhone: 'Telefon (mobilni)',
      place: 'Grad\\Opština',
      municipalities: 'Sedište organa',
      institutionType: 'Tip organa',
      institutionName: 'Naziv organa',
      kjs: 'KJS',
      role: 'Rola',
      pib: 'PIB',
      uniqueKjsNumber: 'Jedinstveni broj KJS',
    },
    NotificationMessages: {
      errorTitle: 'Greška',
      userTitle: 'Korisnik',
      updateSuccessMessage: 'Korisnik je uspešno izmenjen',
    },
    Tooltips: {
      addItem: 'Dodaj KJS',
    },
    ConfirmDialog: {
      deleteKjsMunicipality: 'Да ли заиста желите да обришете КЈС?',
    },
  },

  UserList: {
    rowPerPage: 'Broj redova na stranici',
    of: ' od ',
  },

  UserTable: {
    HeaderColumns: {
      firstName: 'Ime',
      lastName: 'Prezime',
      username: 'Imejl',
      active: 'Aktivan',
      activateDeactivate: 'Aktiviraj / Deaktiviraj',
      edit: 'Izmena',
    },
    titleTable: 'Korisnici',
  },

  UserRow: {
    Tooltips: {
      activate: 'Aktiviraj korisnika',
      deactivate: 'Deaktiviraj korisnika',
    },
    ConfirmDialog: {
      deactivateUserMessage:
        'Da li želite da deaktivirate izabranog korisnika?',
      activateUserMessage: 'Da li želite da aktivirate izabranog korisnika?',
      deactivate: ', deaktiviraj!',
      activate: ', aktiviraj!',
    },
  },

  RequestForSignetApprovalForm: {
    title: ' Zahtev za davanje saglasnosti na sadržinu i izgled pečata',
    Buttons: {
      back: 'Nazad',
      next: 'Nastavi',
      quit: 'Odustani',
      save: 'Sačuvaj',
      saveFinalStep: 'Sačuvaj zahtev',
      submit: 'Podnesi zahtev',
    },
    ConfirmDialog: {
      confirmMessage: 'Da li želite da odustanete od kreiranja zahteva?',
      confirmDelete: ', odustani!',
    },
    Errors: {
      placeEmpty: 'Potrebno je odabrati grad\\opštinu',
      municipalityEmpty: 'Potrebno je odabrati sedište organa',
      institutionTypeEmpty: 'Potrebno je odabrati tip organa',
      kjsEmpty: 'Potrebno je odabrati KJS',
      signetNumberEmpty: 'Potrebno je uneti broj pečata',
      coatOfArmsAppearanceEmpty: 'Potrebno je odabrati grb',
      invalidFileSize: 'Veličina priloga mora biti manja od 10MB',
      uploadedFilesEmpty: 'Potrebno je učitati dokumente',
      invalidFormat: 'Fajl mora da bude u .pdf ili .docx formatu',
    },
    NotificationMessages: {
      requestTitle: 'Zahtev',
      draftUnsuccess:
        'Proverite da li su na adekvatan način popunjena sva obavezna polja',
    },
  },

  FirstStep: {
    Placeholders: {
      place: 'Grad\\Opština',
      municipalities: 'Sedište organa',
      institutionType: 'Tip organa',
      institutionName: 'Naziv organa',
      countryName: 'Naziv države',
      autonomousProvince: 'Naziv teritorijalne pripadnosti',
      organizationalUnits: 'Organizacione jedinice',
      organizationalUnit1: 'Organizaciona jedinica - nivo 1',
      organizationalUnit2: 'Organizaciona jedinica - nivo 2',
      organizationalUnit3: 'Organizaciona jedinica - nivo 3',
      organizationalUnitPlace: 'Sedište organizacione jedinice',
      identificationNumber: 'Matični broj',
      uniqueNumber: 'Jedinstveni broj KJS',
      pib: 'PIB',
      kjs: 'KJS',
      referenceNumber: 'Delovodni broj predmeta',
    },
    Tooltips: {
      municipality: 'Unesi naziv opštine',
    },
  },
  SecondStep: {
    Placeholders: {
      coatOfArmsAppearance: 'Izgled grba',
      signetSizes: 'Veličina pečata',
      signetNumber: 'Broj pečata',
      ordinalNumber: 'Redni broj',
      languageAndScript: 'Jezik i pismo',
      nationalMinorities: 'Jezik i pismo nacionalnih manjina',
    },
    Questions: {
      signetForm: 'Forma pečata',
      signetScript:
        'Da li se pečat ispisuje na Srpskom jeziku, latiničnom pismu?',
      nationalMinorities:
        'Da li se pečat ispisuje na jeziku nacionalnih manjina?',
    },
    Choices: {
      digital: 'Elektronski',
      imprintShape: 'Forma otiska',
    },
  },
  ThirdStep: {
    Placeholders: {
      note: 'Napomena uz zahtev',
      upload: 'Učitajte priloge',
    },
  },

  DecisionTypeList: {
    rowPerPage: 'Broj redova',
    of: ' od ',
  },

  DecisionTypeTable: {
    HeaderColumns: {
      name: 'Ime',
      description: 'Opis',
      preview: 'Pregled',
      edit: 'Izmena',
      delete: 'Brisanje',
    },
    Labels: {
      titleTable: 'Tipovi rešenja',
    },
    Tooltips: {
      addNew: 'Dodaj novi tip rešenja',
    },
  },

  DecisionTypeRow: {
    ConfirmDialog: {
      confirmMessage: 'Da li želite da obrišete tip rešenja?',
      confirmDelete: ', obriši!',
    },
  },

  ModalForAddDecisionType: {
    Labels: {
      title: 'Dodavanje novog tipa rešenja',
      uploadDecision: '  Priložite tip rešenja',
      fileTitlePreview: '  Priložite tip rešenja...',
    },
    Errors: {
      name: 'Potrebno je uneti naziv tipa rešenja.',
      description: 'Potrebno je uneti opis tipa rešenja.',
      invalidFileSize: 'Veličina fajla je veća od 10MB',
      invalidFileFormat: 'Fajl nije u docx formatu',
      fileNotUploaded: 'Fajl nije učitan',
      invalidFormat: 'Fajl mora da bude u .docx formatu',
    },
    Placeholders: {
      name: 'Naziv',
      description: 'Opis',
    },
    Tooltips: {
      decisionAttachment: 'Priložite tip rešenja',
    },
  },

  ModalForAddPlaceToAutonomousProvince: {
    Labels: {
      title: 'Izaberite teritorijalnu pripadnost',
    },
    Errors: {
      autonomousProvince: 'Potrebno je izabrati teritorijalnu pripadnost.',
    },
    Placeholders: {
      autonomousProvince: 'Teritorijalna pripadnost',
    },
  },

  ModalForDecisionTypeUpdateAndPreview: {
    Labels: {
      title: 'Izmena tipa rešenja',
      uploadDecision: 'Priložite rešenje',
      fileTitlePreview: 'Pregled tipa rešenja',
    },
    Errors: {
      name: 'Potrebno je uneti naziv tipa rešenja.',
      description: 'Potrebno je uneti opis tipa rešenja.',
      invalidFileSize: 'Veličina fajla je veća od 10MB',
      invalidFileFormat: 'Fajl nije u docx formatu',
      fileNotUploaded: 'Fajl nije učitan',
    },
    Placeholders: {
      name: 'Naziv',
      description: 'Opis',
    },
    Tooltips: {
      editDecisionAttachment: 'Priložite novi tip rešenja',
    },
  },

  ModalForPreviewSubmissionDataSignet: {
    Labels: {
      title: 'Pregled dostavljenih podataka о izrađenim pečatima',
      uploadDecision: '  Priložite dokument',
      fileTitlePreview: '  Priložite dokument...',
    },
    Placeholders: {
      uniqueSerialNumber: 'Jedinstveni serijski broj',
      plannedStart: 'Važi od',
      validUntil: 'Važi do',
      description: 'Opis',
    },
    Tooltips: {
      editDecisionAttachment: 'Priložite novi tip rešenja',
    },
  },
  ModalForPreviewAttachmentSubmissionDataSignet: {
    Labels: {
      title: 'Pregled priloga',
      look: 'Veličine i izgleda pečata',
      destroyed: 'Zapisnik о uništenju pečata',
    },
    Placeholders: {
      look: 'Pregled величине i izgleda pečata',
      destroyed: 'Pregled zapisnika о uništenju pečata',
    },
  },
  CheckboxGroupTwoChoices: {
    Labels: {
      choice1: 'Da',
      choice2: 'Ne',
    },
  },

  RequestForSignetApprovalList: {
    rowPerPage: 'Broj redova',
    of: ' od ',
  },

  RequestForSignetApprovalTable: {
    HeaderColumns: {
      kjsName: 'Institucija',
      status: 'Status zahteva',
      placeAndMunicipality: 'Sedište organa',
      uniqueNumber: 'Jedinstveni broj KJS',
      identificationNumber: 'Matični broj',
      pib: 'PIB',
      createdAt: 'Datum kreiranja',
      processing: 'Obrada',
      decisionStatus: 'Status rešenja',
      clientsEmail: 'Imejl',
      note: 'Napomena',
    },
    Labels: {
      titleTable: 'Zahtev za davanje saglasnosti na sadržinu i izgled pečata',
    },
    Tooltips: {
      addNew: 'Dodaj novi zahtev',
      note: 'Pregled napomene',
      noteEmpty: 'Ne postoji napomena',
    },
    NotificationMessages: {
      requestTitle: 'Zahtev',
      draftSuccess: 'Zahtev je uspešno sačuvan',
      submitSuccess: 'Zahtev je uspešno podnet',
    },
  },

  RequestForSignetApprovalRow: {
    ConfirmDialog: {
      confirmMessage: 'Da li želite da obrišete zahtev?',
      confirmDelete: ', obriši!',
      confirmDecisionCreationMessage: 'Da li želite da kreirate rešenje?',
      confirmDecisionCreation: ', kreiraj!',
    },
  },

  ModalForAddDecision: {
    Labels: {
      title: 'Dodavanje novog rešenja',
      uploadDecision: '  Priložite rešenje',
      fileTitlePreview: '  Priložite rešenje...',
    },
    Errors: {
      decisionType: 'Tip rešenja je obavezno polje',
      fileNotUploaded: 'Fajl nije učitan',
      invalidFormat: 'Fajl mora da bude u .pdf ili .docx formatu',
      invalidFileSize: 'Veličina fajla je veća od 10MB',
    },
    Placeholders: {
      decisionType: 'Tip rešenja',
    },
    Tooltips: {
      decisionAttachment: 'Priložite rešenje',
    },
  },

  SignetFilter: {
    plannedStartFrom: 'Datum početka upotrebe od',
    plannedStartTo: 'Datum početka upotrebe do',
    signetState: 'Stanje pečata',
    signetStatus: 'Status pečata',
    requestForSignetApproval: 'Delovodni broj predmeta',
    uniqueSerialNumber: 'Jedinstveni serijski broj',
    submitDateFrom: 'Datum kreiranja zahteva od',
    submitDateTo: 'Datum kreiranja zahteva do',
    AccordionForm: {
      reset: 'Obriši',
      filter: 'Filtriraj',
      title: 'Filteri',
    },
  },

  Dashboard: {
    Email: {
      subject: 'Saglasnost za pečat - pristup',
      body:
        'Poštovani,%0D%0A%0D%0AIzmenama i dopunama Zakona o pečatu državnih i drugih organa ("Službeni glasnik RS", broj 101/2007 i 49/2021) predviđena je upotreba kvalifikovanog elektronskog pečata čime se omogućava izdavanje akata organa u elektronskom obliku.%0D%0AZahtev za saglasnost na elektronski pečat podnosi rukovodilac organa.%0D%0AUkoliko rukovodilac organa ovlasti neko drugo lice za podnošenje zahteva za elektronski pečat potrebno je da uz zahtev za registraciju, dostavite skenirano ovlašćenje rukovodioca organa za to lice.%0D%0A%0D%0APodaci o organu%0D%0A%0D%0ANaziv organa:%0D%0AGrad/Opština:%0D%0ASedište organa:%0D%0AJedinstveni broj KJS-a:%0D%0A%0D%0APodaci o ovlašćenom licu%0D%0A%0D%0AJMBG:%0D%0AIme:%0D%0APrezime:%0D%0AImejl:%0D%0A%0D%0ASkeniran dopis sa podacima o organu i ovlašćenom licu prosledite nam putem imejla epecat.mduls@mduls.gov.rs.',
    },
    Messages: {
      message1: 'Ovde možete podneti ',
      messageBold:
        'Zahtev za pribavljanje saglasnosti na sadržinu i izgled pečata, ',
      message2: ' obavestiti nadležni organ о promeni statusa pečata.',
      accessMessageQuestionPart: 'Nemate pristup?',
      accessMessagePart: 'Obratite se administratoru sistema ',
      linkMessage: ' ovde.',
    },
    Buttons: {
      message: 'Podnesi zahtev',
    },
  },

  RequestForSignetApprovalProcessingView: {
    Labels: {
      title: 'Obrada zahteva',
      documentTitle: 'Dokumenti',
      actionTitle: 'Akcije',
      decisionTitle: 'Rešenje',
      previewTitle: 'Pregled zahteva',
    },
    Placeholders: {
      place: 'Grad\\Opština',
      municipality: 'Sedište organa',
      institutionType: 'Tip organa',
      institutionName: 'Naziv organa',
      countryName: 'Naziv države',
      autonomousProvince: 'Naziv teritorijalne pripadnosti',
      organizationalUnit: 'Organizaciona jedinica',
      identificationNumber: 'Matični broj',
      uniqueNumber: 'Jedinstveni broj KJS',
      pib: 'PIB',
      kjs: 'KJS',
      referenceNumber: 'Delovodni broj predmeta',
      coatOfArmsAppearance: 'Izgled grba',
      signetSizes: 'Veličina pečata',
      numberOfSignets: 'Broj pečata',
      ordinalNumber: 'Redni broj',
      languageAndScript: 'Jezik i pismo',
      nationalMinorities: 'Jezik i pismo nacionalnih manjina',
      note: 'Napomena uz zahtev',
      signetForm: 'Forma pečata',
      decisionStatus: 'Status rešenja',
      status: 'Status zahteva',
      date: 'Kreiranje zahteva',
      decisionCreationDate: 'Kreiranje rešenja',
    },
    Tooltips: {
      edit: 'Izmena',
      accept: 'Odobri zahtev',
      addProccesor: 'Prihvatanje zahteva za obradu',
      complementRequired: 'Potrebna dopuna',
      decisionCreation: 'Kreiraj rešenje',
      downloadProposalSolutiоn: 'Preuzmi predlog rešenja',
      createReferenceNumber: 'Unos delovodnog broja',
      updateReferenceNumber: 'Izmena delovodnog broja',
      uploadDecision: 'Priloži rešenje',
      verifeidDecision: 'Potvrdi rešenje',
      downloadDecision: 'Preuzmi potpisano rešenje',
      sendDecision: 'Pošalji rešenje',
      complementRequiredContent: 'Dopuna po zahtevu',
      deliveredDecision: 'Potvrdite dostavljenost rešenja',
      saveEdit: 'Podnesi dopunjen zahtev',
      downloadRequest: 'Preuzimanje zahteva',
      requestStatusRevert: 'Promena statusa zahteva',
      decisionStatusRevert: 'Promena statusa rešenja',
      complementationHistory: 'Pregled istorije dopuna',
      requestCreatorEdit: 'Promena podnosioca zahteva',
    },
    ConfirmDialog: {
      confirmMessageProcessor: 'Da li želite da prihvatite zahtev?',
      confirmDeleteProcessor: '',
      confirmMessage: 'Da li želite da odobrite zahtev?',
      confirmDelete: '',
      confirmMessageVerified: 'Da li želite da potvrdite rešenje?',
      confirmDeleteVerified: '',
      confirmMessageSend: 'Da li želite da pošaljete rešenje?',
      confirmDeleteSend: '',
      confirmMessageDelivered: 'Da li je rešenje dostavljeno?',
      confirmAltAnswerDelivered: '',
      confirmMessageFinishUpdate: 'Da li želite da podnesete dopunjen zahtev?',
      confirmRevertRequestStatusMessage:
        'Da li zaista želite da vratite zahtev u obradu?',
      confirmRevertDecisionStatusMessage:
        'Da li zaista želite da vratite rešenje u izradu?',
      confirmRequestCreatorChange:
        'Da li zaista želite da promenite podnosioca zahteva?',
    },
    NotificationMessages: {
      requestTitle: 'Zahtev',
      decisionTitle: 'Rešenje',
      decisionFinalTitle: 'Potpisano rešenje',
      complementRequiredTitle: 'Potrebna dopuna zahteva',
      complementedTitle: 'Dopunjen zahtev',
      proposalDecisionTitle: 'Predlog rešenja',
      decisionTitleError: 'Greška',
      complementError: 'Greška',
      successAddProcessor: 'Uspešno ste prihvatili zahtev za obradu',
      successReferenceNumber: 'Uspešno ste kreirali delovodni broj predmeta',
      successReferenceNumberUpdate:
        'Uspešno ste izmenili delovodni broj predmeta',
      successComplementRequired: 'Uspešno ste kreirali zahtev za dopunu',
      successUpdate: 'Uspešno ste potvrdili dopunu zahteva',
      saveSuccessUpdate: 'Uspešno ste dopunili zahtev',
      successSubmittedRequest: 'Uspešno ste podneli zahtev',
      successAcceptRequest: 'Uspešno ste odobrili zahtev',
      successUploadDecision: 'Uspešno ste priložili rešenje',
      succesVerifiedDecision: 'Uspešno ste potvrdili rešenje',
      successDownload: 'Uspešno ste preuzeli dokument',
      unsuccessDownload: 'Došlo je do greške prilikom preuzimanja dokumenta',
      successSent: 'Uspešno ste poslali dokument',
      unsuccessSent: 'Došlo je do greške prilikom slanja dokumenta',
      unsuccessMessage: 'Zahtev sa datim delovodnim brojem, već postoji!',
      succesDeliveredDecision:
        'Potvrda dostavljenog rešenja je uspešno izvršena',
      draftSuccess: 'Zahtev je uspešno sačuvan',
      successInProcessingRequest: 'Status zahteva je uspešno promenjen',
      succesInPreparationDecision: 'Status rešenja je uspešno promenjen',
      successUpdateRequest: 'Uspešno ste izmenili zahtev',
    },
  },

  AttachmentTable: {
    name: 'Naziv',
    preview: 'Pregled',
    download: 'Preuzimanje',
    nameUploaded: 'Priloženi dokumenti',
    delete: 'Brisanje',
  },
  RequestForSignetApprovalFilter: {
    'kjs.name': 'Naziv institucije',
    'kjs.uniqueNumber': 'Jedinstveni broj KJS',
    referenceNumber: 'Delovodni broj predmeta',
    'municipality.name': 'Sedište organa',
    'place.name': 'Grad\\Opština',
    createdAtFrom: 'Datum kreiranja od',
    createdAtTo: 'Datum kreiranja do',
    'kjs.pib': 'PIB',
    status: 'Status zahteva',
    AccordionForm: {
      reset: 'Obriši',
      filter: 'Filtriraj',
      title: 'Filteri',
    },
  },

  KjsFilter: {
    'kjs.uniqueNumber': 'Jedinstveni broj KJS',
    kjsEntity: 'KJS',
    municipality: 'Sedište organa',
    referenceNumber: 'Delovodni broj predmeta',
    'municipality.name': 'Sedište organa',
    'place.name': 'Grad\\Opština',
    createdAtFrom: 'Datum kreiranja od',
    createdAtTo: 'Datum kreiranja do',
    'kjs.pib': 'PIB',
    institutionType: 'Tip',
    AccordionForm: {
      reset: 'Obriši',
      filter: 'Filtriraj',
      title: 'Filteri',
    },
  },

  PlaceFilter: {
    autonomousProvince: 'Teritorijalna pripadnost',
    'municipality.name': 'Sedište organa',
    name: 'Naziv grada\\opštine',
    createdAtFrom: 'Datum kreiranja od',
    createdAtTo: 'Datum kreiranja do',
    AccordionForm: {
      reset: 'Obriši',
      filter: 'Filtriraj',
      title: 'Filteri',
    },
  },

  MunicipalityFilter: {
    'place.name': 'Naziv grada',
    name: 'Sedište organa',
    createdAtFrom: 'Datum kreiranja od',
    createdAtTo: 'Datum kreiranja do',
    AccordionForm: {
      reset: 'Obriši',
      filter: 'Filtriraj',
      title: 'Filteri',
    },
  },

  ModalForCreateRequestApprovalReferenceNumber: {
    Labels: {
      title: 'Kreiranje delovodnog broja zahteva',
      titleUpdate: 'Izmena delovodnog broja zahteva',
    },
    Errors: { referenceNumber: 'Potrebno je uneti delovodni broj predmeta' },
    Placeholders: {
      referenceNumber: 'Unesite delovodni broj predmeta...',
      referenceNumberForPreview: 'Delovodni broj predmeta',
    },
  },

  ModalForUpdateRequestCreator: {
    Labels: {
      title: 'Promena podnosioca zahteva',
    },
    Errors: {
      client: 'Potrebno je odabrati novog podnosioca zahteva',
    },
    Placeholders: {
      client: 'Odaberite novog podnosioca zahteva',
    },
  },

  ModalForViewComplementRequestHistory: {
    Labels: {
      title: 'Pregled istorije dopuna zahteva',
    },
  },

  ModalForViewComplementSignetHistory: {
    Labels: {
      title: 'Pregled istorije dopuna pečata',
    },
  },

  ComplementRequestHistoryTable: {
    HeaderColumns: {
      description: 'Napomena',
      creator: 'Obradjivač',
      createdAt: 'Datum promene',
      requestClient: 'Podnosilac zahteva',
    },
    titleTable: 'Pregled istorije napomene',
  },

  ComplementSignetTableHistory: {
    HeaderColumns: {
      description: 'Napomena',
      creator: 'Obradjivač',
      createdAt: 'Datum promene',
    },
    titleTable: 'Pregled istorije napomene',
  },

  ModalForUpdateRequestApprovalReferenceNumber: {
    Labels: {
      title: 'Izmena delovodnog broja predmeta',
    },
    Errors: { referenceNumber: 'Potrebno je uneti delovodni broj predmeta' },
    Placeholders: {
      referenceNumber: 'Unesite delovodni broj predmeta...',
      referenceNumberForPreview: 'Delovodni broj predmeta',
    },
  },

  ModalForAddRequestForSignetStatus: {
    Labels: {
      title: 'Prijava promene statusa pečata',
    },
    Errors: {
      status: 'Potrebno je izabrati status',
      uploadedDocument: 'Potrebno je priložiti dokument',
      invalidFileSize: 'Veličina fajla je veća od 10MB',
      invalidFormat: 'Fajl mora da bude u .pdf ili .docx formatu',
    },
    Placeholders: {
      statusSignet: 'Status pečata',
      uploadedDocument: 'Priložite dokument',
    },
    NotificationMessages: {
      requestForSignetStatus: 'Promena statusa pečata',
      successCreateRequestForSignetStatus:
        'Uspešno ste kreirali zahtev za promenu statusa pečata',
      successAccepetRequestForSigentStatus:
        'Uspešno ste prihvatili zahtev za promenu statusa pečata',
    },
  },

  DecisionFilter: {
    decisionStatus: 'Status rešenja',
    'decisionType.name': 'Tip rešenja',
    createdAtFrom: 'Datum kreiranja rešenja od',
    createdAtTo: 'Datum kreiranja rešenja do',
    kjs: 'KJS',
    submitDateFrom: 'Datum kreiranja zahteva od',
    submitDateTo: 'Datum kreiranja zahteva do',
    AccordionForm: {
      reset: 'Obriši',
      filter: 'Filtriraj',
      title: 'Filteri',
    },
  },

  SignetProcessingView: {
    Labels: {
      title: 'Obrada pečata',
      actionTitle: 'Akcije',
      documentTitle: 'Dokumenti',
      requestForSignetStatusTitle: 'Dokumenti prijave promene statusa pečata',
    },
    Placeholders: {
      request: 'Zahtev',
      organizationalUnit: 'Organ',
      plannedStart: 'Datum nabavke',
      statusChangedDate: 'Datum promene statusa',
      beginOfUsage: 'Početak upotrebe',
      authorizedPerson: 'Ovlašćeno lice',
      signetState: 'Stanje',
      signetStatus: 'Status',
      uniqueSerialNumber: 'Jedinstveni serijski broj',
      validUntil: 'Kraj upotrebe',
      sigentState: 'Stanje pečata',
      sigentStatus: 'Status pečata',
      notificationStartFrom: 'Početak važenja pečata je za: ',
      days: ' dana',
      day: ' dan',
    },
    Value: {
      validate: 'Validirano',
    },
    Tooltips: {
      showRequest: 'Pregled zahteva',
      showAttachmentRequest: 'Pregled priloga',
      complementSignet: 'Dostavljanje podataka о izrađenim pečatima',
      changeState: 'Promena stanja',
      complementRequired: 'Potrebna dopuna',
      complementSignetContent: 'Sadržaj potrebne dopune',
      approve: 'Završi pečat',
      reject: 'Odbaci pečat',
      requestForSignetStatus: 'Prijava promene statusa pečata',
      acceptRequestForSignetStatus:
        'Prihvatanje prijave promene statusa pečata',
      acceptComplemened: 'Potvrda dostavljenih podataka',
      updateComplementSignet:
        'Izmena dostavljenih podataka о izrađenim pečatima',
      downloadExample: 'Preuzmite spoljni prikaz elektronskog pečata',
      requestPreview: 'Pregled zahteva',
      uploadSignetDestroyed: 'Učitavanje zapisnika о uništenju pečata',
      complementationHistory: 'Pregled istorije dopuna',
    },
    ConfirmDialog: {
      confirmMessage: 'Da li zaista želite da promenite stanje pečata u',
      confirm: ', promeni',
      confirmApproveMessage: 'Da li zaista želite da završite pečat?',
      confirmRejectMessage: 'Da li zaista želite da odbacite pečat?',
      confirmAcceptRequestForSignetStatus:
        'Da li zaista želite da prihvatite promenu statusa pečata?',
      confirmComplementedMessage:
        'Da li zaista želite da potvrdite promene podataka о izrađenim pečatima?',
    },
    NotificationMessages: {
      signet: 'Pečat',
      complementSignet: 'Dopuna',
      complementError: 'Greška',
      requestForSignetStatus: 'Promena statusa pečata',
      submissionDataSignet: 'Dostavljanje podataka о izrađenim pečatima',
      complementationSignet: 'Potrebna dopuna dostavljenih podataka',
      successComplementRequired: 'Uspešno ste kreirali zahtev za dopunu',
      successComplementedSubmission:
        'Uspešno ste dostavili podatke о izrađenom pečatu',
      successSubmissionDataCreate:
        'Uspešno ste dostavili podatke о izrađenom pečatu',
      successSubmissionDataUpdate:
        'Uspešno ste sačuvali podatke о izrađenom pečatu',
      successAcceptSignet: 'Uspešno ste završili pečat',
      unsuccessSubmissionData:
        'Pečat sa datim jedinstvenim serijskim brojem, već postoji!',
      successCreateRequestForSignetStatus:
        'Uspešno ste kreirali zahtev za promenu statusa pečata',
      successAccepetRequestForSigentStatus:
        'Uspešno ste prihvatili zahtev za promenu statusa pečata',
      successDownloadExample:
        'Uspešno ste preuzeli spoljni prikaz elektronskog pečata organa',
      unsuccessDownload: 'Došlo je do greške prilikom preuzimanja dokumenta',
      successSignetDestroyedUpload: 'Dokument je uspešno učitan',
      unsuccessSignetDestroyedUpload:
        'Došlo je do greške prilikom učitavanja dokumenta',
      uploadSignetDestroyed: 'Učitavanje zapisnika о uništenju pečata',
      unsuccessfulDownload: 'Došlo je do greške prilikom preuzimanja dokumenta',
    },
  },
  ModalWithPredefinedUsers: {
    Labels: {
      title: 'Izaberite korisnika',
    },
    Placeholders: {
      coatOfArmsAppearance: 'Korisnici',
    },
    Errors: {
      user: 'Potrebno je izabrati korisnika !',
    },
  },

  ModalForPreviewRequestApproval: {
    Labels: {
      title: 'Pregled zahteva',
    },
    Placeholders: {},
  },

  KjsList: {
    rowPerPage: 'Broj redova',
    of: ' od ',
  },

  KjsTable: {
    HeaderColumns: {
      identificationNumber: 'Matični broj',
      name: 'Naziv',
      uniqueNumber: 'Jedinstveni broj KJS',
      pib: 'PIB',
      municipality: 'Sedište organa',
      institutionType: 'Tip organa',
      update: 'Izmena naziva',
      updateMunicipality: 'Izmena sedišta organa',
      activateDeactivate: 'Aktiviraj/Deaktiviraj',
      user: 'Korisnik',
    },
    ConfirmDialog: {
      confirmMessage: 'Da zaiste želite da pokrenete sinhornizaciju za KJS?',
      confirmActivateMessage: 'Da zaiste želite da aktivirate KJS?',
      confirmDeactivateMessage: 'Da zaiste želite da deaktivirate KJS?',
      deactivate: ', deaktiviraj!',
      activate: ', aktiviraj!',
    },
    titleTable: 'Korisnici javnih sredstava',
    synchronization: 'Sinhronizacija KJS',
    Tooltips: {
      update: 'Promena naziva',
      updateMunicipality: 'Promena sedišta organa',
    },
    NotificationMessages: {
      kjs: 'KJS',
      kjsUpdateNameSuccessefully: 'Uspešno ste promenili naziv KJS-a',
      kjsUpdateMunicipalitySuccessefully:
        'Uspešno ste promenili sedište organa KJS-a',
      kjsActivateSuccessefully: 'Uspešno ste aktivirali KJS',
      kjsDeactivateSuccessefully: 'Uspešno ste deaktivirali KJS',
    },
  },

  ModalForUpdateKjsName: {
    Labels: {
      title: 'Promena naziva KJS-a',
    },
    Placeholders: {
      kjsName: 'Naziv KJS-a',
    },
  },

  ModalForUpdateKjsMunicipality: {
    Labels: {
      title: 'Promena sedišta organa',
    },
    Errors: {
      kjs: 'Potrebno je uneti KJS.',
      municipality: 'Potrebno je uneti sedište organa.',
    },
    Placeholders: {
      place: 'Grad\\Opština',
      municipality: 'Sedište organa',
      institutionType: 'Tip organa',
      pib: 'PIB',
      uniqueKjsNumber: 'Jedinstveni broj KJS',
      kjs: 'KJС',
    },
  },

  PlaceList: {
    rowPerPage: 'Broj redova',
    of: ' od ',
  },

  PlaceTable: {
    HeaderColumns: {
      name: 'Naziv',
      autonomousProvince: 'Teritorijalna pripadnost',
      addAutonomousProvince: 'Izaberite teritorijalnu pripadnost',
      updatePlace: 'Izmena mesta',
    },
    titleTable: 'Grad\\Opština',
    Tooltips: {
      addPlace: 'Dodaj mesto',
      updatePlaceName: 'Promeni naziv mesta',
      updateAutonomousProvnice: 'Dodaj teritorijalnu pripadnost',
    },
    NotificationMessages: {
      place: 'Mesto',
      addPlaceSuccessfully: 'Uspešno ste dodali novo mesto',
      updatePlaceSuccessfully: 'Uspešno ste izmenili mesto',
    },
  },

  MunicipalityList: {
    rowPerPage: 'Broj redova',
    of: ' od ',
  },

  MunicipalityTable: {
    HeaderColumns: {
      name: 'Naziv',
      place: 'Grad\\Opština',
      addPlace: 'Izaberite grad\\opštinu',
      updateMunicipality: 'Izmena sedišta organa',
    },
    titleTable: 'Sedište organa',
    Tooltips: {
      addMunicipality: 'Dodaj sedište organa',
      updateMunicipality: 'Promeni naziv sedišta organa',
      updatePlace: 'Dodaj mesto',
    },
    NotificationMessages: {
      municipality: 'Sedište organa',
      addMunicipalitySuccessfully: 'Uspešno ste dodali novo sedište organa',
      updateMunicipalitySuccessfully:
        'Uspešno ste izmenili novo sedište organa',
    },
  },

  ModalForAddMunicipalityToPlace: {
    Labels: {
      title: 'Dodavanje mesta sedišta organa',
      titleUpdate: 'Promena mesta sedišta organa',
    },
    Placeholder: {
      place: 'Mesto',
    },
    Errors: {
      place: 'Potrebno je odabrati mesto',
    },
  },

  ModalForUpdateMunicipalityName: {
    Labels: {
      titleUpdate: 'Promena naziva sedišta organa',
      title: 'Dodavanje sedišta organa',
    },
    Placeholders: {
      name: 'Naziv sedišta ogrgana',
      place: 'Mesto',
    },
    Errors: {
      name: 'Potrebno je uneti naziv sedišta organa',
      place: 'Potrebno je odabrati mesto sedišta organa',
    },
  },

  MunicipalityRow: {
    Tooltips: {
      updatePlace: 'Додајте место',
      updateMunicipality: 'Промени седиште органа',
    },
  },

  ModalForAddOrUpdatePlace: {
    title: 'Modal za dodvanje mesta',
    Placeholders: {
      placeName: 'Naziv mesta',
    },
    Errors: {
      placeName: 'Potrebno je uneti naziv mesta',
    },
  },

  PlaceRow: {
    Tooltips: {
      autonomousProvince: 'Izaberite teritorijalnu pripadnost',
    },
  },
  ModalForUploadSignetDestroyedAttachment: {
    Labels: {
      title: 'Učitavanje zapisnika о uništenju pečata',
    },
    Placeholders: {
      uploadSignetDestroyed: 'Učitajte zapisnik о uništenju pečata',
    },
  },

  SignetExampleList: {
    rowPerPage: 'Broj redova',
    of: ' od ',
  },

  SignetExampleTable: {
    Labels: { titleTable: 'Spoljni prikaz elektronskog pečata' },
    HeaderColumns: {
      name: 'Naziv',
      preview: 'Pregled',
      download: 'Preuzimanje',
    },
    Tooltips: {
      addNew: 'Učitajte novi dokument',
    },
    NotificationMessages: {
      signetExample: 'Spoljni prikaz elektronskog pečata',
    },
  },
  ModalForUploadSignetExample: {
    Labels: {
      title: 'Učitavanje spoljnog prikaza elektronskog pečata',
    },
    Placeholders: {
      uploadSignetDestroyed: 'Učitajte spoljni prikaz elektronskog pečata',
    },
    Errors: {
      imageNotUploaded: 'Fajl nije učitan',
      invalidFileSize: 'Veličina fajla je veća od 10MB',
      invalidFormat: 'Fajl mora da bude u .pdf ili .docx formatu',
    },
  },
  SignetExampleRow: {
    NotificationMessages: {
      signet: 'Spoljni prikaz elektronskog pečata',
      successDownloadExample:
        'Uspešno ste preuzeli spoljni prikaz elektronskog pečata',
      unsuccessfulDownload: 'Došlo je do greške prilikom preuzimanja dokumenta',
    },
  },
  ModalForDocumentPreview: {
    filePreviewTitle: 'Greška',
  },

  UnauthorizedAccess: {
    cardTitle:
      'Nemate pravo pristupa sistemu, molimo vas da se obratite administratoru na adresu ',
    Email: {
      subject: 'Saglasnost za pečat - pristup',
      body:
        'Poštovani,%0D%0A%0D%0AIzmenama i dopunama Zakona o pečatu državnih i drugih organa ("Službeni glasnik RS", broj 101/2007 i 49/2021) predviđena je upotreba kvalifikovanog elektronskog pečata čime se omogućava izdavanje akata organa u elektronskom obliku.%0D%0AZahtev za saglasnost na elektronski pečat podnosi rukovodilac organa.%0D%0AUkoliko rukovodilac organa ovlasti neko drugo lice za podnošenje zahteva za elektronski pečat potrebno je da uz zahtev za registraciju, dostavite skenirano ovlašćenje rukovodioca organa za to lice.%0D%0A%0D%0APodaci o organu%0D%0A%0D%0ANaziv organa:%0D%0AGrad/Opština:%0D%0ASedište organa:%0D%0A%0D%0APodaci o ovlašćenom licu%0D%0A%0D%0AJMBG:%0D%0AIme:%0D%0APrezime:%0D%0AImejl:%0D%0A%0D%0ASkeniran dopis sa podacima o organu i ovlašćenom licu prosledite nam putem imejla epecat.mduls@mduls.gov.rs.',
    },
  },
  KJSMunicipalityTable: {
    kjs: 'KJS',
    delete: 'Brisanje',
  },

  UserFilter: {
    firstName: 'Ime',
    lastName: 'Prezime',
    role: 'Uloga',
    kjs: 'KJS',
    municipality: 'Sedište organa',
    AccordionForm: {
      reset: 'Obriši',
      filter: 'Filtriraj',
      title: 'Filteri',
    },
  },
};
